import { FC } from 'react'

import styles from '../style.module.scss'
import clsx from 'clsx'

export const HorizontalControls: FC<{ className?: string }> = props => {
  const { className } = props
  return <div className={clsx(styles.horizontalControls, className)}>{props.children}</div>
}
